import { getDeviceType } from "@/helpers/getDeviceType"

export type RuleEntry = {
  id: number
  textKey: string
  needsStatement?: boolean
  // Text contains {left_key} / {right_key} / {up_key}, rendered as key icons
  hasKeys?: boolean
}

export type AssessmentRulesConfig = {
  titleModal: string
  subtitleModal?: string
  descriptionAssessment?: string[]
  titleRules: string
  rules: RuleEntry[]
}

const device = getDeviceType() === "desktop" ? "web" : "mobile"

export const ASSESSMENT_RULES: Record<string, AssessmentRulesConfig> = {
  Swipe: {
    titleModal: "swipe.rules.modal.title",
    subtitleModal: "swipe.rules.modal.about.title",
    descriptionAssessment: [
      "swipe.landing.body_1",
      "swipe.landing.body_2",
      "swipe.landing.body_3",
    ],
    titleRules: "swipe.rules.title",
    rules: [
      { id: 1, textKey: `swipe.rules.rule_1_${device}`, hasKeys: true },
      { id: 2, textKey: `swipe.rules.rule_2_${device}`, hasKeys: true },
      { id: 3, textKey: "swipe.rules.rule_3" },
    ],
  },
  Brain: {
    titleModal: "brain.rules.modal.title",
    subtitleModal: "brain.rules.modal.about.title",
    descriptionAssessment: ["brain.landing.body_1", "brain.landing.body_2"],
    titleRules: "brain.rules.title",
    rules: [1, 2, 3, 4].map((i) => ({
      id: i,
      textKey: `brain.rules.rule_${i}`,
    })),
  },
  Drive: {
    titleModal: "drive.rules.modal.title",
    subtitleModal: "drive.rules.modal.about.title",
    descriptionAssessment: ["drive.landing.body_1", "drive.landing.body_2"],
    titleRules: "drive.rules.title",
    rules: [1, 2, 3, 4, 5].map((i) => ({
      id: i,
      textKey: `drive.rules.rule_${i}`,
    })),
  },
  Move: {
    titleModal: "move.rules.modal.title",
    subtitleModal: "move.rules.modal.about.title",
    descriptionAssessment: ["move.landing.body_1", "move.landing.body_2"],
    titleRules: "move.rules.title",
    rules: [1, 2, 3, 4, 5].map((i) => ({
      id: i,
      textKey: `move.rules.rule_${i}`,
      needsStatement: i === 2,
    })),
  },
  MoveBis: {
    titleModal: "movebis.rules.modal.title",
    subtitleModal: "movebis.rules.modal.about.title",
    descriptionAssessment: ["movebis.landing.body_1", "movebis.landing.body_2"],
    titleRules: "movebis.rules.title",
    rules: [1, 2, 3, 4, 5].map((i) => ({
      id: i,
      textKey: `movebis.rules.rule_${i}`,
      needsStatement: i === 2,
    })),
  },
  Voice: {
    titleModal: "voice.rules.modal.title",
    subtitleModal: "voice.rules.modal.about.title",
    descriptionAssessment: ["voice.rules.modal.about.body"],
    titleRules: "voice.rules.modal.recap.title",
    rules: [
      { id: 1, textKey: "voice.rules.modal.recap.bullet_1" },
      { id: 2, textKey: "voice.rules.modal.recap.bullet_2" },
      { id: 3, textKey: "voice.rules.modal.recap.bullet_3" },
    ],
  },
}
